<template>
  <el-row>
    <el-col :span="10">
      <el-card>
        <div
          slot="header"
          class="clearfix"
        >
          <span>Számlázási cím</span>
        </div>
        <el-form
          ref="billingAddressForm"
          label-position="top"
          :model="billingAddress"
          :rules="rules"
        >
          <el-form-item
            label="Irányítószám"
            prop="postal_code"
          >
            <el-input
              v-model="billingAddress.postal_code"
              @change="onBillingZipChange"
            />
          </el-form-item>
          <el-form-item
            label="Város"
            prop="city"
            v-loading="billingLoading"
          >
            <el-input
              v-model="billingAddress.city"
            />
          </el-form-item>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item
                label="Ország"
                prop="country"
                v-loading="billingLoading"
              >
                <el-select
                  v-model="billingAddress.country"
                  value-key="id"
                  style="width: 100%;"
                  filterable
                >
                  <el-option
                    v-for="country in countries"
                    :key="country.id"
                    :value="country"
                    :label="country.name"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                label="Megye"
                prop="county"
                v-loading="billingLoading"
              >
                <el-select
                  v-model="billingAddress.county"
                  value-key="id"
                  style="width: 100%;"
                  filterable
                >
                  <el-option
                    v-for="county in counties"
                    :key="county.id"
                    :value="county"
                    :label="county.name"
                  />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item
            label="Cím"
            prop="address"
          >
            <el-input
              v-model="billingAddress.address"
            />
          </el-form-item>
        </el-form>
      </el-card>
    </el-col>
    <el-col :span="4" style="text-align: center">
      <div>
        <el-button size="small" @click="copyAddress">
          Másolás
          <i class="el-icon-arrow-right"></i>
        </el-button>
      </div>
      <div style="margin-top: 20px;">
        <el-button size="small" @click="copyDeliveryAddress">
          <i class="el-icon-arrow-left"></i>
          Másolás
        </el-button>
      </div>
    </el-col>
    <el-col :span="10">
      <el-card>
        <div
          slot="header"
          class="clearfix"
        >
          <span>Szállítási cím</span>
        </div>
        <el-form
          ref="deliveryAddressForm"
          label-position="top"
          :model="deliveryAddress"
          :rules="rules"
        >
          <el-form-item
            label="Irányítószám"
            prop="postal_code"
          >
            <el-input
              v-model="deliveryAddress.postal_code"
              @change="onDeliveryZipChange"
            />
          </el-form-item>
          <el-form-item
            label="Város"
            prop="city"
            v-loading="deliveryLoading"
          >
            <el-input
              v-model="deliveryAddress.city"
            />
          </el-form-item>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item
                label="Ország"
                prop="country"
                v-loading="deliveryLoading"
              >
                <el-select
                  v-model="deliveryAddress.country"
                  value-key="id"
                  style="width: 100%;"
                  filterable
                >
                  <el-option
                    v-for="country in countries"
                    :key="country.id"
                    :value="country"
                    :label="country.name"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                label="Megye"
                prop="county"
                v-loading="deliveryLoading"
              >
                <el-select
                  v-model="deliveryAddress.county"
                  value-key="id"
                  style="width: 100%;"
                  filterable
                >
                  <el-option
                    v-for="county in counties"
                    :key="county.id"
                    :value="county"
                    :label="county.name"
                  />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item
            label="Cím"
            prop="address"
          >
            <el-input
              v-model="deliveryAddress.address"
            />
          </el-form-item>
        </el-form>
      </el-card>
    </el-col>
  </el-row>
</template>
<script>
export default {
  props: ['billingAddr', 'deliveryAddr'],
  data() {
    return {
      billingAddress: {},
      deliveryAddress: {},
      billingLoading: false,
      deliveryLoading: false,
      rules: {
        country: [
          {
            required: true,
            message: 'Ország megadása kötelező',
            trigger: 'change'
          }
        ],
        postal_code: [
          {
            required: true,
            message: 'Irányítószám megadása kötelező',
            trigger: 'change'
          }
        ],
        city: [
          {
            required: true,
            message: 'Város megadása kötelező',
            trigger: 'change'
          }
        ],
        address: [
          {
            required: true,
            message: 'Cím kötelező',
            trigger: 'change'
          }
        ],
      },
    };
  },
  methods: {
    copyAddress() {
      this.deliveryAddress = JSON.parse(JSON.stringify(this.billingAddress));
    },
    copyDeliveryAddress() {
      this.billingAddress = JSON.parse(JSON.stringify(this.deliveryAddress));
    },
    async onBillingZipChange() {
      this.billingLoading = true;
      const data = await axios.get('/api/city/' + this.billingAddress.postal_code);
      if (data) {
        this.$set(this.billingAddress, 'city', data.city);
        this.$set(this.billingAddress, 'county_id', data.county_id);
        this.$set(this.billingAddress, 'county', this.counties.find(c => c.id === data.county_id));
        this.$set(this.billingAddress, 'country_id', data.country_id);
        this.$set(this.billingAddress, 'country', this.countries.find(c => c.id === data.country_id));
      } else {
        this.$set(this.billingAddress, 'city', null);
        this.$set(this.billingAddress, 'county', null);
        this.$set(this.billingAddress, 'county_id', null);
      }
      this.billingLoading = false;
    },
    async onDeliveryZipChange() {
      this.deliveryLoading = true;
      const data = await axios.get('/api/city/' + this.deliveryAddress.postal_code);
      if (data) {
        this.$set(this.deliveryAddress, 'city', data.city);
        this.$set(this.deliveryAddress, 'county_id', data.county_id);
        this.$set(this.deliveryAddress, 'county', this.counties.find(c => c.id === data.county_id));
        this.$set(this.deliveryAddress, 'country_id', data.country_id);
        this.$set(this.deliveryAddress, 'country', this.countries.find(c => c.id === data.country_id));
      } else {
        this.$set(this.deliveryAddress, 'city', null);
        this.$set(this.deliveryAddress, 'county', null);
        this.$set(this.deliveryAddress, 'county_id', null);
      }
      this.deliveryLoading = false;
    },
  },
  computed: {
    countries() {
      return this.$store.getters['country/countries'];
    },
    counties() {
      return this.$store.getters['county/counties'];
    },
  },
  async mounted() {
    await this.$store.dispatch('country/fetchAll');
    await this.$store.dispatch('county/fetchAll');
    this.billingAddress = this.billingAddr;
    this.deliveryAddress = this.deliveryAddr;
  }
};
</script>
